import { render } from "./OnlineComplete.vue?vue&type=template&id=6de7e46e&scoped=true&ts=true"
import script from "./OnlineComplete.vue?vue&type=script&lang=ts"
export * from "./OnlineComplete.vue?vue&type=script&lang=ts"

import "./OnlineComplete.vue?vue&type=style&index=0&id=6de7e46e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1361425700/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6de7e46e"]])

export default __exports__